/**
 * Literals specific to the wizard's **UserMenu** (account icon + popover).
 *
 * Follows the configurator's per-component token convention (see the area's
 * `*.tokens.ts` blocks): the few values the Figma uses that have no exact match
 * in the shared `CFG` palette live here, re-using `CFG` for everything else so
 * the styled-components carry no raw literals.
 *
 * Geometry note — the popover/icon are anchored to the top-right of the preview
 * pane, just left of the docked sidebar. `anchorRight` reproduces the Figma gap:
 * sidebar right margin (16) + sidebar width (390, see WizardLayout.styles `Side`)
 * + the 16px gap between the icon and the sidebar = 422px from the viewport edge.
 */
import { themed } from '../../../../../theme/themeRegistry';

export const USER_MENU = themed('cfgUserMenu', {
  /** Popover surface (Figma `surface/surface` #18181b — darker than CFG.surface). */
  surface: '#18181b',
  /** Foreground value text (Figma `foreground/foreground` #fcfcfc). */
  fg: '#fcfcfc',
  /** Logout button wash (brand orange @ 15% — Figma ButtonTwo fill). */
  logoutBg: 'rgba(255, 121, 27, 0.15)',
  /** Logout button hover wash (slightly stronger). */
  logoutHover: 'rgba(255, 121, 27, 0.24)',
  /** Logout label. Dark theme = brand orange; on the light theme the bare brand
   *  orange on the pale orange wash fails AA (~2.3:1), so it deepens to a burnt
   *  orange that clears AA (see themePalette LIGHT_OVERRIDES). */
  logoutText: '#ff791b',

  // Geometry --------------------------------------------------------------
  /** Distance of the icon/popover anchor from the top of the viewport. */
  anchorTop: '32px',
  /** Distance from the viewport right edge: 16 (side margin) + 390 (side width) + 16 (gap). */
  anchorRight: '422px',
  /** Icon button edge (Figma 32×32). */
  iconButton: '32px',
  /** Popover width (Figma 257). */
  popupWidth: '257px',
} as const);
